import { render, staticRenderFns } from "./PortClearanceAndDues.vue?vue&type=template&id=7dd04d0a&"
import script from "./PortClearanceAndDues.vue?vue&type=script&lang=js&"
export * from "./PortClearanceAndDues.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports